import ImagePlayVideo from "components/utility/images/ImagePlayVideo";
import VideoModal from "components/utility/video/VideoModal";
import React, { useState } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";

interface PopupVideoProps {
	data: {
		eyebrow?: string;
		eyebrowColor?: string;
		title?: string;
		titleColor?: string;
		hideTitle?: boolean;
		description?: string;
		hideDescription?: boolean;
		video: string;
		thumbnail: string;
		alt: string;
	};
}

const PopupVideo: React.FC<PopupVideoProps> = ({
	data: { eyebrow, eyebrowColor, title, titleColor, description, video, thumbnail, alt }
}) => {
	const [showModal, setShowModal] = useState(false);

	return (
		<div className="video-container">
			{eyebrow && (
				<div
					className={`video-container-eyebrow t-label-sm-heavy tc-${eyebrowColor}`}
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(eyebrow) }}
				/>
			)}
			{title && (
				<div className="video-container-title">
					<h2 className={`t-heading-xl tc-${titleColor}`}>{title}</h2>
				</div>
			)}
			{description && (
				<div
					className={`video-container-description t-body-sm tc-cool-gray-01`}
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(description) }}
				></div>
			)}
			<div className="popup-video-wrapper">
				<VideoModal
					showClose={true}
					showModal={showModal}
					setShowModal={setShowModal}
					vid={video}
				/>
				<button
					className="popup-video-thumbnail"
					aria-label="open video"
					onClick={() => setShowModal(true)}
				>
					<img src={thumbnail} alt={alt} />
					<ImagePlayVideo />
				</button>
			</div>
		</div>
	);
};

export default PopupVideo;
